module.exports = __webpack_public_path__ + "media/images/loading-spinner-524d9ba136044705651dbeaf5fb3b9c6.gif";